const { site, internalName, brand, images, domainName } = window.settings
const { general, cta } = brand
const notifications = window.settings.notifications || {}
const webPush = notifications.webPush ? notifications.webPush : {}

const webManifest = {
	"name": site,
	"short_name": site,
	"background_color": cta.primary.backgroundColor,
	"icons": [
		{
		  "src": (images && images.pwaLogo && images.pwaLogo.pwaLogo72x72) || "",
		  "sizes": "72x72",
		  "type": "image/png"
		},
		{
		  "src": (images && images.pwaLogo && images.pwaLogo.pwaLogo96x96) || "",
		  "sizes": "96x96",
		  "type": "image/png"
		},
		{
		  "src": (images && images.pwaLogo && images.pwaLogo.pwaLogo128x128) || "",
		  "sizes": "128x128",
		  "type": "image/png"
		},
		{
		  "src": (images && images.pwaLogo && images.pwaLogo.pwaLogo144x144) || "",
		  "sizes": "144x144",
		  "type": "image/png"
		},
		{
		  "src": (images && images.pwaLogo && images.pwaLogo.pwaLogo152x152) || "",
		  "sizes": "152x152",
		  "type": "image/png"
		},
		{
		  "src": (images && images.pwaLogo && images.pwaLogo.pwaLogo192x192) || "",
		  "sizes": "192x192",
		  "type": "image/png"
		},
		{
		  "src": (images && images.pwaLogo && images.pwaLogo.pwaLogo384x384) || "",
		  "sizes": "384x384",
		  "type": "image/png"
		},
		{
		  "src": (images && images.pwaLogo && images.pwaLogo.pwaLogo512x512) || "",
		  "sizes": "512x512",
		  "type": "image/png"
		}
	  ],
	"start_url": "https://"+domainName,
	"theme_color": cta.primary.backgroundColor,
	"display": "standalone",
}

export const initializeWebWorker = () => {
	const blob = new Blob([JSON.stringify(webManifest)], {type: 'application/json'})
	const manifestURL = URL.createObjectURL(blob)
	document.querySelector('#manifest-placeholder').setAttribute('href', manifestURL);
}

export const requestUserPermission = () => {
	if(window.clevertap){
		window.clevertap.notifications.push({
			"titleText": webPush.titleText,
			"bodyText": webPush.bodyText,
			"okButtonText": webPush.okButtonText,
			"rejectButtonText": webPush.rejectButtonText,
			"okButtonColor": cta.primary.backgroundColor,
			"serviceWorkerPath": '/sw.js'
		})		
	}
}